import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';
import type { PaginationMeta } from '@core/http-types';
import type { LocationBrief } from '@core/locations-types';

@Injectable({
  providedIn: 'root',
})
export class LocationsByCompanyHttpService {
  private readonly httpApi = inject(HttpApiService);

  public fetchOne$(
    id: string,
    page: number,
  ): Observable<{ locations: LocationBrief[]; id: string; meta: PaginationMeta }> {
    const url = `${this.httpApi.appConfig.apiUrl}c/${id}/locations`;

    return this.httpApi.get(url, { page }, { skipURLBuild: true }).pipe(
      map(response => ({
        locations: response.locations,
        id,
        meta: response.meta,
      })),
    );
  }
}
